/* Querysleutels van Businesscases. */

import type { QueryClient } from '@tanstack/react-query';

export const BUSINESSCASES_SLEUTEL = ['businesscases'] as const;

/** Na aanmaken, dupliceren, archiveren of terugzetten: de lijst en de projectpagina opnieuw lezen. */
export function naBusinesscaseWijziging(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: BUSINESSCASES_SLEUTEL });
  qc.invalidateQueries({ queryKey: ['projectpagina'] });
}
